/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { IseeCittadinoDTO } from '../model/models';
import { IseeCittadinoUpsertForm } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface DeleteIseeCittadinoRequestParams {
    id: string;
}

export interface UpsertIseeCittadinoRequestParams {
    iseeCittadinoUpsertForm: IseeCittadinoUpsertForm;
}


export interface ISEECittadinoServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Cancella una voce del proprio storico ISEE.
     * Audience: CITTADINO. 404 privacy-preserving se la voce non appartiene al caller.
     * @endpoint delete /api/v1/cittadino/isee/{id}
* @param requestParameters
     */
    deleteIseeCittadino(requestParameters: DeleteIseeCittadinoRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Lista del proprio storico ISEE.
     * Audience: CITTADINO. Ritorna le voci ISEE del caller ordinate per anno decrescente.
     * @endpoint get /api/v1/cittadino/isee
*/
    listIseeCittadino(extraHttpRequestParams?: any): Observable<Array<IseeCittadinoDTO>>;

    /**
     * Upsert di una voce ISEE per anno.
     * Audience: CITTADINO. Insert se l\&#39;anno non esiste, update del valore altrimenti (un solo ISEE per anno per utente).
     * @endpoint put /api/v1/cittadino/isee
* @param requestParameters
     */
    upsertIseeCittadino(requestParameters: UpsertIseeCittadinoRequestParams, extraHttpRequestParams?: any): Observable<IseeCittadinoDTO>;

}
